<template>
  <v-card class="mx-auto">
    <v-list>
      <v-list-item v-if="globalSearchResults.length === 0">
        <v-list-item-subtitle>
          <span>「{{ globalSearchWord }}」に一致するユーザーは見つかりませんでした。</span>
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item
        :key="user.userId"
        v-else
        v-for="user in globalSearchResults"
        @click="toUserPage(user.userId)"
      >
        <v-list-item-avatar>
          <v-img :src="user.userPhotoURL" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="user.userName" />
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle>
            <v-row
              align="center"
              justify="center"
            >
              <v-col>
                <v-icon small> mdi-star-circle </v-icon>
                <span> {{ user.userAchievementPower }} </span>
              </v-col>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle v-text="user.userProfile" />
        </v-list-item-content>

        <v-list-item-action>
          <v-row v-if="user.friendStatus === 1">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon @click="approve(user)"> mdi-account-check </v-icon>
                </v-btn>
              </template>
              <span> 申請を承認する </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon @click="reject(user)"> mdi-account-remove </v-icon>
                </v-btn>
              </template>
              <span> 申請を拒否する </span>
            </v-tooltip>
          </v-row>

          <v-row v-else-if="user.friendStatus === 2">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon @click="discontinue(user)"> mdi-account-cancel </v-icon>
                </v-btn>
              </template>
              <span> 申請を中止する </span>
            </v-tooltip>
          </v-row>

          <v-row v-else-if="user.friendStatus === 3">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="release(user)"
                >
                  <v-icon> mdi-account-minus </v-icon>
                </v-btn>
              </template>
              <span> 友達関係を解除する </span>
            </v-tooltip>
          </v-row>

          <v-row v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon @click="apply(user)"> mdi-account-plus </v-icon>
                </v-btn>
              </template>
              <span> 友達申請を送る </span>
            </v-tooltip>
          </v-row>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "globalSearchWord",
      "loginUserId",
      "user/users"
    ]),
    // 検索結果
    globalSearchResults() {
      const globalSearchResults = [];
      this["user/users"].forEach(user => {
        if (user.userId !== this.loginUserId) {
          if (this.globalSearchWord !== "") {
            if (user.userName.toLowerCase().indexOf(this.globalSearchWord.toLowerCase()) > -1) {
              user.userFriends.forEach(friend => { if (friend.friendUserId === this.loginUserId) user.friendStatus = friend.friendStatus });
              globalSearchResults.push(user);
            }
          } else {
            user.userFriends.forEach(friend => { if (friend.friendUserId === this.loginUserId) user.friendStatus = friend.friendStatus });
            globalSearchResults.push(user);
          }
        }
      });
      return globalSearchResults;
    },
  },

  data: () => ({
    linkControl: true,
  }),

  methods: {
    ...mapActions([
      "friend/apply",
      "friend/approve",
      "friend/discontinue",
      "friend/reject",
      "friend/release",
      "user/updateUsersFriendStatus",
    ]),
    // 友達申請を送ります.
    async apply(user) {
      this.linkControl = false;
      await this["friend/apply"](user).then((returnValue) => {
        if (returnValue !== false) {
          this["user/updateUsersFriendStatus"]({ friendStatus: 2, otherUserId: user.userId });
        }
      });
      this.$emit("rerender")
    },
    // 友達申請を承認します.
    async approve(user) {
      this.linkControl = false;
      await this["friend/approve"](user).then((returnValue) => {
        if (returnValue !== false) {
          this["user/updateUsersFriendStatus"]({ friendStatus: 3, otherUserId: user.userId });
        }
      })
      this.$emit("rerender")
    },
    // 友達申請を中止します.
    async discontinue(user) {
      this.linkControl = false;
      await this["friend/discontinue"](user).then((returnValue) => {
        if (returnValue !== false) {
          this["user/updateUsersFriendStatus"]({ friendStatus: 0, otherUserId: user.userId });
        }
      })
      this.$emit("rerender")
    },
    // 友達申請を拒否します.
    async reject(user) {
      this.linkControl = false;
      await this["friend/reject"](user).then((returnValue) => {
        if (returnValue !== false) {
          this["user/updateUsersFriendStatus"]({ friendStatus: 0, otherUserId: user.userId });
        }
      })
      this.$emit("rerender")
    },
    // 友達関係を解除します.
    async release(user) {
      this.linkControl = false;
      await this["friend/release"](user).then((returnValue) => {
        if (returnValue !== false) {
          this["user/updateUsersFriendStatus"]({ friendStatus: 0, otherUserId: user.userId });
        }
      })
      this.$emit("rerender")
    },
    // ユーザーページに遷移します.
    toUserPage(userId) { if (this.linkControl) this.$router.push({ name: "User", params: { "user_id": userId } }); },
  }
};
</script>
